import $ from 'jquery'
// import Swiper from 'swiper';

// export const scrollToTop = () => {
//     var swiper = new Swiper('.swiper-container', {
//         slidesPerView: 'auto',
//         centeredSlides: true,
//         spaceBetween: 30,
//         pagination: {
//           el: '.swiper-pagination',
//           clickable: true,
//         },
//       });

// }

export const contScrollToBottom = (id) => {
  if(id){
    const container = document.getElementById(id);
    container.scrollTop = container.scrollHeight;
  }
}

export const contScrollToTop = (id) => {
  if(id){
    const container = document.getElementById(id);
    container.scrollTop = 0;
  }
}

export const hideScrolltoTopHandler = (id,callback) => {
  if(id){
    const container = document.getElementById(id);
    let scroll_top = container.scrollTop;
    // console.log("container.scrollTop and container.scrollHeight/2",container.scrollTop,container.scrollHeight/2)
    if(scroll_top > 80){
      callback(true);
    }else{
      callback(false)
    }
  }
}

export const hideScrolltoBottomHandler = (id, callback, adjustOffset) => {
  if(id){
    let extraOffset = adjustOffset ? adjustOffset : 0

    const container = document.getElementById(id);
      // console.log('$(`#${id}`).scrollTop() + $(`#${id}`).height() == $(document).height()',$(`#${id}`).scrollTop() + $(`#${id}`).height(), $(document).width() * 2 + 150, container.scrollHeight)
      if($(`#${id}`).scrollTop() + $(`#${id}`).height() >= container.scrollHeight - 35 - extraOffset) {
        console.log('content hide ')
        callback(true);
      } else{
        console.log('content show ')
        callback(false)
      }

  }
}